import Cookies from "js-cookie";

export const COACH_ACCESS_TOKEN_KEY = "coach_access_token";
export const COACH_USER_KEY = "coach_user";

export type CoachAuthUser = {
  id: string;
  firstName?: string;
  lastName?: string;
  email?: string | null;
  profileImage?: { url?: string } | null;
};

export function getCoachAccessToken(): string | null {
  if (typeof window === "undefined") return null;
  return (
    localStorage.getItem(COACH_ACCESS_TOKEN_KEY) ||
    Cookies.get(COACH_ACCESS_TOKEN_KEY) ||
    null
  );
}

export function getCoachUser(): CoachAuthUser | null {
  if (typeof window === "undefined") return null;
  const raw = localStorage.getItem(COACH_USER_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw) as CoachAuthUser;
  } catch {
    return null;
  }
}

export function setCoachAuth(
  token: string,
  user: CoachAuthUser,
  rememberMe = true,
): void {
  const cookieOptions = rememberMe ? { expires: 365 } : undefined;
  Cookies.set(COACH_ACCESS_TOKEN_KEY, token, cookieOptions);
  localStorage.setItem(COACH_ACCESS_TOKEN_KEY, token);
  localStorage.setItem(COACH_USER_KEY, JSON.stringify(user));
}

export function clearCoachAuth(): void {
  Cookies.remove(COACH_ACCESS_TOKEN_KEY);
  localStorage.removeItem(COACH_ACCESS_TOKEN_KEY);
  localStorage.removeItem(COACH_USER_KEY);
}
